import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { formatFechaHora, eventoCorreoConfig } from "../helpers"

const CorreosTab = ({ data }) => {
  const correos = data?.correos || []

  // Agrupar por destinatario
  const porDestinatario = useMemo(() => {
    const map = new Map()
    correos.forEach(c => {
      const key = c.destinatario || "(sin destinatario)"
      if (!map.has(key)) map.set(key, [])
      map.get(key).push(c)
    })
    // Ordenar eventos de cada destinatario por fecha desc
    map.forEach(items => {
      items.sort((a, b) => (b.fecha || "").localeCompare(a.fecha || ""))
    })
    return Array.from(map.entries()).map(([destinatario, eventos]) => ({
      destinatario,
      eventos,
      ultimoEvento: eventos[0],
    }))
  }, [correos])

  if (correos.length === 0) {
    return (
      <div style={{ padding: 60, textAlign: "center", color: "#64748b" }}>
        <i className="mdi mdi-email-off-outline" style={{ fontSize: 48, color: "#cbd5e1" }} />
        <div className="mt-2">Sin eventos de correo registrados para esta factura.</div>
      </div>
    )
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <h6 style={{ margin: 0, color: "#0f172a", fontWeight: 600 }}>
        <i className="mdi mdi-email-multiple-outline me-2 text-primary" />
        {correos.length} evento{correos.length !== 1 ? "s" : ""} en {porDestinatario.length} destinatario{porDestinatario.length !== 1 ? "s" : ""}
      </h6>

      {porDestinatario.map(({ destinatario, eventos, ultimoEvento }, idx) => {
        const ultimoCfg = eventoCorreoConfig(ultimoEvento?.evento)
        return (
          <div key={idx} style={{
            background: "#fff", border: "1px solid #e2e8f0",
            borderLeft: `4px solid ${ultimoCfg.color}`,
            borderRadius: 10, padding: 16,
          }}>
            <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap mb-3">
              <div>
                <div style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600, letterSpacing: 0.4 }}>
                  Destinatario
                </div>
                <div style={{ fontSize: 14, color: "#0f172a", fontWeight: 600, marginTop: 2 }}>
                  <i className="mdi mdi-email-outline text-primary me-1" />
                  {destinatario}
                </div>
              </div>
              <span style={{
                background: ultimoCfg.bg, color: ultimoCfg.color,
                padding: "3px 10px", borderRadius: 999,
                fontSize: 11, fontWeight: 700, textTransform: "uppercase",
              }}>
                <i className={`mdi mdi-${ultimoCfg.icon} me-1`} />
                Último: {ultimoCfg.label}
              </span>
            </div>

            {/* Timeline de eventos */}
            <div style={{ position: "relative", paddingLeft: 24 }}>
              <div style={{
                position: "absolute", left: 8, top: 6, bottom: 6,
                width: 2, background: "#e2e8f0",
              }} />
              {eventos.map((ev, i) => {
                const cfg = eventoCorreoConfig(ev.evento)
                const esUltimo = i === 0
                return (
                  <div key={i} style={{ position: "relative", paddingBottom: 12 }}>
                    <div style={{
                      position: "absolute", left: -19, top: 4,
                      width: 14, height: 14, borderRadius: "50%",
                      background: esUltimo ? cfg.color : "#cbd5e1",
                      border: "3px solid #fff",
                      boxShadow: "0 0 0 1px #cbd5e1",
                    }} />
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{
                          background: cfg.bg, color: cfg.color,
                          padding: "2px 8px", borderRadius: 4,
                          fontSize: 11, fontWeight: 700, textTransform: "uppercase",
                        }}>
                          <i className={`mdi mdi-${cfg.icon} me-1`} />
                          {cfg.label}
                        </span>
                        {ev.plataforma && (
                          <span style={{ fontSize: 11, color: "#94a3b8" }}>
                            · {ev.plataforma}
                          </span>
                        )}
                      </div>
                      <span style={{ fontSize: 12, color: "#64748b" }}>
                        {formatFechaHora(ev.fecha)}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

CorreosTab.propTypes = { data: PropTypes.object }

export default CorreosTab
